import React from 'react'
import { Tabs } from 'antd'
import { CreateDepositHeadwayForm } from '../CreateDepositHeadwayForm'
import { CreateDepositNovaForm } from '../CreateDepositNovaForm'
import { Guard } from '../../../../features/session/guard'
import { GUARD_RULES } from '../../../../features/session/constants'

export const CreateDeposits = () => {
  return (
    <Tabs
      items={[
        {
          key: 'headway',
          label: 'Headway',
          children: <CreateDepositHeadwayForm />,
        },
        {
          key: 'nova',
          label: 'Nova',
          children: (
            <Guard permission={GUARD_RULES.CREATE_MANUAL_DEPOSIT_NOVA}>
              <CreateDepositNovaForm />
            </Guard>
          ),
        },
      ]}
    />
  )
}
